export const siteSettings = {
  name: "Pro Markets Hub",
  link: "https://promarketshub.net",
  email: "support@promarketshub.net",
  appLink: "https://app.promarketshub.net",
};
